"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eth_chainId = void 0;
const index_js_1 = require("../utils/index.js");
// https://eips.ethereum.org/EIPS/eip-695
const eth_chainId = (_params, ctx) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield ctx.tronClient.get(`/wallet/getnodeinfo`);
    const p2pVersion = data.configNodeInfo.p2pVersion;
    return index_js_1.numberToHex(p2pVersion);
});
exports.eth_chainId = eth_chainId;
